// frontend/src/modules/integrations/period.ts
//
// Date ranges for the QuickBooks finance widget, in the user's local
// calendar (QBO interprets report dates in the company's own timezone —
// local-month boundaries are the closest honest approximation).

export type FinancePeriod = 'this_month' | 'last_month' | 'ytd';

function iso(d: Date): string {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

export function periodRange(period: FinancePeriod, now: Date): { start: string; end: string } {
  if (period === 'last_month') {
    const start = new Date(now.getFullYear(), now.getMonth() - 1, 1);
    const end = new Date(now.getFullYear(), now.getMonth(), 0); // day 0 = last day of prev month
    return { start: iso(start), end: iso(end) };
  }
  if (period === 'ytd') {
    return { start: iso(new Date(now.getFullYear(), 0, 1)), end: iso(now) };
  }
  return { start: iso(new Date(now.getFullYear(), now.getMonth(), 1)), end: iso(now) };
}

export const PERIOD_LABELS: Record<FinancePeriod, string> = {
  this_month: 'This month',
  last_month: 'Last month',
  ytd: 'Year to date',
};
